import { InjectionToken } from '@angular/core';
import * as msTeamsMgtToken from '@microsoft/mgt-element';

// Microsoft Graph Toolkit token
export const MSTeamsMgtToken = new InjectionToken('msTeamsMgtToken');

export function teamsMgtTokenProvider() {
  return msTeamsMgtToken;
}
